import { FunctionComponentElement, useState } from "react";
import { NodeInputProps } from "./index";
import { Button } from "primereact/button";
import { InputSwitch } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";
import "./array.scss";
import { Dialog } from "primereact/dialog";
import { CodeEditor } from "../code/CodeEditor";
import { useDispatch } from "react-redux";
import { setToast } from "../../app/appSlice";
import { ErrorDefaultValueWidget } from "../error/errorDefaultValueWidget";
import { InputNumber } from "primereact/inputnumber";

export const ArrayInput = ({
  typeParam,
  value,
  onChange,
  defaultValue
}: NodeInputProps): FunctionComponentElement<NodeInputProps> => {
  const [showAll, setShowALl] = useState<boolean>(false);
  const [showDialog, setShowDialog] = useState<boolean>(false);
  const [valuesImported, setValuesImported] = useState<string>();

  const [incorrectDefaultValue, setIncorrectDefaultValue] =
  useState<boolean>(false);




  const verifyType = (value: any, type:any) => {
    if (Array.isArray(value)) {
      let typeToCheck
      if(type === "number") typeToCheck = "number"
      else typeToCheck = "string"
      for(let i of value) {
        if(typeof i !== typeToCheck) {
          return false
        }
      }
    } else return false
    return true;
  };


  const [arrayValues, setArrayValues] = useState<(string | number)[]>(() => {
    if (value) return value;
    if (defaultValue) {
      if (verifyType(defaultValue,typeParam)) return defaultValue;
      else setIncorrectDefaultValue(true);
    }
    return [];
  }
  );
  const dispatch = useDispatch();




  const addItem = () => {
    setArrayValues(['', ...arrayValues.filter(val => val)]);
    onChange(arrayValues.filter(val => val));
    setIncorrectDefaultValue(false)
  };
  const deleteItem = (index: number) => {
    arrayValues.splice(index, 1);
    setArrayValues([...arrayValues]);
    onChange(arrayValues.filter(val => val));
  };
  const updateValue = (
    index: number,
    newValue: string | number
  ) => {
    if (typeParam && typeParam === "number" && isNaN(Number(newValue))) {
      return;
    }

    arrayValues[index] = newValue;
    setArrayValues([...arrayValues]);
    onChange(arrayValues.filter(val => val));
  };

  const headerDialog = () => {
    return <>
        Copier / écrire le tableau de valeurs que vous souhaitez importer ({typeParam !== "" ? typeParam : "string"})
        <br/><span> {typeParam == "number" ? 'Exemple: [1,1.02,4]' : 'Exemple: ["texte1","texte2"]'}</span>
      </>
  };

  const validatorOfArrayImported = (): void => {
    let errorMsg;
    let valueParsed;

    try {
      valueParsed = JSON.parse(valuesImported!);
      if (!Array.isArray(valueParsed)) {
        errorMsg = "Format du tableau incorrect !";
      }

      if (valueParsed.length === 0) {
        errorMsg = "Tableau vide ! Veuillez saisir des valeurs";
      }

      const getTypeOfParam = typeParam === "number" ? typeParam : "string";
      for (const value of valueParsed) {
        if (typeof value !== getTypeOfParam) {
          errorMsg = `Les valeurs du tableau n'ont pas toutes le bon type (${getTypeOfParam})`;
          break;
        }
      }
    } catch {
      errorMsg = "Format incorrect !";
    }

    if (errorMsg) {
        dispatch(
            setToast({
                title: "Erreur d'import de données",
                content: errorMsg,
                life: 3000,
                severity: "error",
            })
        );
    } else {
        onChange(valueParsed);
        setArrayValues(valueParsed);
        setValuesImported(undefined);
        setShowDialog(false);
    }
  };

  const footerDialog = () => {
    return (
      <>
        <div className="flex justify-content-end mt-1">
          <Button
            label={"Annuler"}
            type="button"
            onClick={() => {
              setValuesImported(undefined);
              setShowDialog(false);
            }}
            className="m-2 p-button-outlined p-button-sm"
          />

          <Button
            label={"Importer"}
            type="button"
            disabled={!valuesImported}
            onClick={() => {
              if (
                window.confirm(
                  "Etes vous sûr de vouloir importer les données ? Attention, toutes les données du tableau seront écrasées par l'import"
                )
              ) {
                validatorOfArrayImported();
              }
            }}
            className="m-2 p-button-sm"
          />
        </div>
      </>
    );
  };

  return (
    <>
      <Dialog
        header={headerDialog}
        visible={showDialog}
        onHide={() => {
          setValuesImported(undefined);
          setShowDialog(false);
        }}
        footer={footerDialog}
      >
        <CodeEditor
          defaultValue={valuesImported ?? ''}
          lang={"json"}
          valueUpdated={(value) => {
            setValuesImported(value);
          }}
        />
      </Dialog>
      <ErrorDefaultValueWidget displayError={incorrectDefaultValue} ></ErrorDefaultValueWidget>
      <div className="avro mt-5 mb-2">
        <div className="flex justify-content-between align-items-center">
          <div className="array-title">Valeur(s) du tableau</div>
          {arrayValues.length > 0 && (
              <Button
                type="button"
                onClick={() => {
                    if (window.confirm(
                        "Etes vous sûr de vouloir supprimer toutes les données du tableau ?"
                    )) {
                        setArrayValues([]);
                        onChange([]);
                    }
                }}
                icon="pi pi-trash"
                className="p-button-outlined"
              />
          )}
        </div>
        <div className="flex arrayContainer">
          {arrayValues
            .slice(0, showAll ? arrayValues.length : 10)
            .map((value, index) => (
              <div className="rowAvro">
                <div className="fields">
                  <div className="array-input">
                    {typeParam === "number" ? 
                       <InputNumber
                       value={value ? Number(value) : null}
                       mode={"decimal"}
                       maxFractionDigits={20}
                       onChange={(e) => {
                        if (e.value !== null)updateValue(index, e.value);
                      }}
                      placeholder={"Saisissez un nombre"}
                     />
                    :<InputText
                      value={value?.toString()}
                      className="w-full h-full"
                      placeholder={"Saisissez une valeur"}
                      onChange={(e) => {
                        updateValue(index, e.target.value);
                      }}
                    />}
                  </div>
                </div>

                <Button
                  type="button"
                  onClick={() => {
                      deleteItem(index);
                  }}
                  icon="pi pi-times"
                  className="p-button-outlined"
                />
              </div>
            ))}
        </div>
        {arrayValues.length > 10 && (
          <div className="show-all">
            <span className="show-all-label">Afficher plus de 10 données</span>
            <InputSwitch
              checked={showAll}
              onChange={(e) => setShowALl(e.value)}
            />
          </div>
        )}
        <div className="flex justify-content-center">
          <Button
            className=" mt-3 p-button-text"
            type="button"
            label="Ajouter une valeur"
            onClick={() => addItem()}
            icon="pi pi-plus"
            size="small"
          />
        </div>
        <div className="flex justify-content-center">
          <Button
            className=" mt-3 p-button-text"
            type="button"
            label="Importer des valeurs"
            onClick={() => setShowDialog(true)}
            icon="pi pi-plus"
            size="small"
          />
        </div>
      </div>
    </>
  );
};
